import { useLocalization as e } from "./localization/index.js";
import { getSchemaType as t } from "./helpers/get-schema-type.js";
import { getModelNameWithArray as n } from "./helpers/schema-name.js";
import { getDisplayTypeSignatureTokens as r } from "./helpers/get-type-signature-tokens.js";
import i from "../shared/Badge.vue.js";
import { isModelLinkable as ee } from "./helpers/is-model-linkable.js";
import te from "./RenderString.vue.js";
import a from "./SchemaPropertyDefault.vue.js";
import o from "./SchemaPropertyDetail.vue.js";
import s from "./SchemaPropertyExamples.vue.js";
import c from "./SchemaPropertyPattern.vue.js";
import { Fragment as l, computed as u, createBlock as d, createCommentVNode as f, createElementBlock as p, createElementVNode as m, createSlots as h, createTextVNode as g, createVNode as _, defineComponent as v, normalizeClass as y, openBlock as b, renderList as x, renderSlot as S, toDisplayString as C, toRef as w, unref as T, withCtx as E } from "vue";
import { resolve as D } from "@scalar/workspace-store/resolve";
import { isDefined as O } from "@scalar/helpers/array/is-defined";
import { isArraySchema as k, isNumberSchema as A, isStringSchema as j } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/SchemaPropertyHeading.vue?vue&type=script&setup=true&lang.ts
var ne = { class: "property-heading [&>.property-detail:has(+.property-detail)]:mr-0" }, re = {
	key: 1,
	class: "property-discriminator"
}, ie = { class: "font-code text-c-accent" }, M = { class: "screenreader-only" }, N = {
	key: 0,
	class: "property-type-signature text-c-2 text-(length:--scalar-mini)"
}, P = {
	key: 1,
	class: "property-type-signature text-c-2 text-(length:--scalar-mini)"
}, F = {
	key: 0,
	class: "screenreader-only"
}, I = {
	key: 3,
	class: "property-additional"
}, L = {
	key: 4,
	class: "property-deprecated"
}, R = {
	key: 5,
	class: "property-const"
}, z = {
	key: 7,
	class: "property-write-only"
}, B = {
	key: 8,
	class: "property-read-only"
}, V = {
	key: 9,
	class: "property-required"
}, H = /*@__PURE__*/ v({
	__name: "SchemaPropertyHeading",
	props: {
		value: {},
		enum: { type: Boolean },
		isDiscriminator: {
			type: Boolean,
			default: !1
		},
		required: {
			type: Boolean,
			default: !1
		},
		additional: { type: Boolean },
		withExamples: {
			type: Boolean,
			default: !0
		},
		hideModelNames: {
			type: Boolean,
			default: !1
		},
		modelLinkOptions: {},
		modelName: {},
		propertyNames: {},
		eventBus: { default: null },
		keyKind: {},
		recursiveTo: {}
	},
	setup(v) {
		let H = v, { translate: U } = e(), W = w(H, "value"), G = u(() => {
			if (!W.value) return;
			let e = W.value;
			if (e.const !== void 0) return e.const;
			if (e.enum?.length === 1) return e.enum[0];
			if (k(e) && e.items) {
				let t = D.schema(e.items);
				if (O(t.const)) return t.const;
				if (t.enum?.length === 1) return t.enum[0];
			}
		}), K = (e) => {
			let t = [];
			return j(e) && (e.minLength && t.push({
				key: "min-length",
				prefix: `${U("schema.minLength")}: `,
				value: e.minLength
			}), e.maxLength && t.push({
				key: "max-length",
				prefix: `${U("schema.maxLength")}: `,
				value: e.maxLength
			})), (j(e) || A(e)) && e.format && t.push({
				key: "format",
				value: e.format,
				truncate: !0
			}), A(e) && (O(e.exclusiveMinimum) && t.push({
				key: "exclusive-minimum",
				prefix: `${U("schema.greaterThan")}: `,
				value: e.exclusiveMinimum
			}), O(e.minimum) && t.push({
				key: "minimum",
				prefix: `${U("schema.min")}: `,
				value: e.minimum
			}), O(e.exclusiveMaximum) && t.push({
				key: "exclusive-maximum",
				prefix: `${U("schema.lessThan")}: `,
				value: e.exclusiveMaximum
			}), O(e.maximum) && t.push({
				key: "maximum",
				prefix: `${U("schema.max")}: `,
				value: e.maximum
			}), O(e.multipleOf) && t.push({
				key: "multiple-of",
				prefix: `${U("schema.multipleOf")}: `,
				value: e.multipleOf
			})), t;
		}, q = u(() => {
			if (!W.value) return [];
			let e = W.value, t = [];
			return k(e) && ((e.minItems || e.maxItems) && t.push({
				key: "array-range",
				value: `${e.minItems || ""}…${e.maxItems || ""}`
			}), e.uniqueItems && t.push({
				key: "unique-items",
				value: `${U("schema.unique")}!`
			})), t.push(...K(e)), k(e) && e.items && t.push(...K(D.schema(e.items))), t;
		}), J = u(() => !H.value || H.hideModelNames ? null : H.modelName ? {
			schemaKey: H.modelName,
			label: H.modelName
		} : n(H.value)), Y = u(() => ee(J.value?.schemaKey, H.modelLinkOptions ?? {})), X = u(() => r(H.value, {
			hideModelNames: H.hideModelNames,
			modelName: J.value?.label
		})), ae = u(() => !H.value || !("type" in H.value) ? !1 : H.value.type === "array" || !G.value), Z = u(() => {
			let e = H.propertyNames;
			if (!e) return;
			let n = [t(e)];
			"format" in e && typeof e.format == "string" && n.push(e.format);
			let r = n.filter(Boolean).join(" · ");
			return r.length > 0 ? r : void 0;
		}), Q = u(() => {
			if (H.value && "example" in H.value && H.value.example !== void 0) return H.value.example;
			if (H.value && k(H.value)) {
				let e = D.schema(H.value.items);
				if (e && "example" in e && e.example !== void 0) return e.example;
			}
		}), oe = u(() => {
			if (Q.value !== void 0) return !0;
			let e = H.value?.examples;
			return !!e && typeof e == "object" && Object.keys(e).length > 0;
		}), $ = u(() => {
			let e = W.value;
			if (e) {
				if (j(e) && e.pattern) return e.pattern;
				if (k(e) && e.items) {
					let t = D.schema(e.items);
					if (j(t) && t.pattern) return t.pattern;
				}
			}
		});
		return (e, t) => (b(), p("div", ne, [
			e.$slots.name ? (b(), p("div", {
				key: 0,
				class: y(["property-name", { deprecated: H.value?.deprecated }])
			}, [S(e.$slots, "name", {}, void 0, !0)], 2)) : f("", !0),
			H.isDiscriminator ? (b(), p("div", re, C(T(U)("schema.discriminator")), 1)) : f("", !0),
			H.value ? (b(), p(l, { key: 2 }, [
				H.keyKind ? (b(), d(o, {
					key: 0,
					class: "property-key-kind"
				}, {
					default: E(() => [m("span", ie, C(H.keyKind === "pattern" ? "patternProperty" : "additionalProperty"), 1)]),
					_: 1
				})) : f("", !0),
				ae.value ? (b(), d(o, {
					key: 1,
					truncate: ""
				}, {
					default: E(() => [m("span", M, C(T(U)("schema.type")) + ": ", 1), H.eventBus && J.value?.schemaKey && Y.value ? (b(), p("button", {
						key: 0,
						class: "text-c-2 hover:text-c-1 underline",
						type: "button",
						onClick: t[0] ||= (e) => H.eventBus.emit("scroll-to:model-by-name", { name: J.value.schemaKey })
					}, [X.value.length ? (b(), p("span", N, [(b(!0), p(l, null, x(X.value, (e, t) => (b(), p(l, { key: t }, [g(C(t > 0 ? " " : ""), 1), m("span", { class: y(["property-type-token", [
						`property-type-token--${e.kind}`,
						e.kind === "word" ? "font-sans" : "",
						e.kind === "ident" || e.kind === "literal" ? "font-code" : "",
						e.kind === "punctuation" ? "text-c-2" : ""
					]]) }, C(e.text), 3)], 64))), 128))])) : f("", !0)])) : X.value.length ? (b(), p("span", P, [(b(!0), p(l, null, x(X.value, (e, t) => (b(), p(l, { key: t }, [g(C(t > 0 ? " " : ""), 1), m("span", { class: y(["property-type-token", [
						`property-type-token--${e.kind}`,
						e.kind === "word" ? "font-sans" : "",
						e.kind === "ident" || e.kind === "literal" ? "font-code" : "",
						e.kind === "punctuation" ? "text-c-2" : ""
					]]) }, C(e.text), 3)], 64))), 128))])) : f("", !0)]),
					_: 1
				})) : f("", !0),
				H.recursiveTo ? (b(), d(o, {
					key: 2,
					class: "property-recursive",
					title: T(U)("schema.recursiveReference", { name: H.recursiveTo })
				}, {
					default: E(() => [g(C(T(U)("schema.recursive")), 1)]),
					_: 1
				}, 8, ["title"])) : f("", !0),
				Z.value ? (b(), d(o, {
					key: 3,
					truncate: ""
				}, {
					prefix: E(() => [g(C(T(U)("schema.keys")) + ":", 1)]),
					default: E(() => [g(" " + C(Z.value), 1)]),
					_: 1
				})) : f("", !0),
				(b(!0), p(l, null, x(q.value, (e) => (b(), d(o, {
					key: e.key,
					code: e.code,
					truncate: e.truncate
				}, h({
					default: E(() => [e.key === "format" ? (b(), p("span", F, C(T(U)("schema.format")) + ": ", 1)) : f("", !0), g(" " + C(e.value), 1)]),
					_: 2
				}, [e.prefix ? {
					name: "prefix",
					fn: E(() => [g(C(e.prefix), 1)]),
					key: "0"
				} : void 0]), 1032, ["code", "truncate"]))), 128)),
				H.enum ? (b(), d(o, { key: 4 }, {
					default: E(() => [g(C(T(U)("schema.enum")), 1)]),
					_: 1
				})) : f("", !0)
			], 64)) : f("", !0),
			H.additional ? (b(), p("div", I, [H.value?.["x-additionalPropertiesName"] ? (b(), p(l, { key: 0 }, [g(C(H.value["x-additionalPropertiesName"]), 1)], 64)) : (b(), p(l, { key: 1 }, [g(C(T(U)("schema.additionalProperties")), 1)], 64))])) : f("", !0),
			H.value?.deprecated ? (b(), p("div", L, [_(i, null, {
				default: E(() => [g(C(T(U)("schema.deprecated")), 1)]),
				_: 1
			})])) : f("", !0),
			G.value === void 0 ? (b(), p(l, { key: 6 }, [H.value?.nullable === !0 ? (b(), d(o, { key: 0 }, {
				default: E(() => [g(C(T(U)("schema.nullable")), 1)]),
				_: 1
			})) : f("", !0)], 64)) : (b(), p("div", R, [_(o, { truncate: "" }, {
				prefix: E(() => [g(C(T(U)("schema.const")) + ": ", 1)]),
				default: E(() => [_(te, { value: G.value }, null, 8, ["value"])]),
				_: 1
			})])),
			H.value?.writeOnly ? (b(), p("div", z, C(T(U)("schema.writeOnly")), 1)) : H.value?.readOnly ? (b(), p("div", B, C(T(U)("schema.readOnly")), 1)) : f("", !0),
			H.required ? (b(), p("div", V, C(T(U)("schema.required")), 1)) : f("", !0),
			H.value?.default === void 0 ? f("", !0) : (b(), d(a, {
				key: 10,
				value: H.value?.default
			}, null, 8, ["value"])),
			$.value ? (b(), d(c, {
				key: 11,
				pattern: $.value
			}, null, 8, ["pattern"])) : f("", !0),
			H.withExamples && oe.value ? (b(), d(s, {
				key: 12,
				example: Q.value,
				examples: H.value?.examples
			}, null, 8, ["example", "examples"])) : f("", !0),
			S(e.$slots, "preview", {}, void 0, !0),
			S(e.$slots, "trailing", {}, void 0, !0)
		]));
	}
});
//#endregion
export { H as default };

//# sourceMappingURL=SchemaPropertyHeading.vue.script.js.map